(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.llista.controller:EntitatsMainLlistaCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llista')
    .controller('EntitatsMainLlistaCtrl', EntitatsMainLlistaCtrl);

  function EntitatsMainLlistaCtrl($scope, HelperFactory, Notification, EntitatFactory, $window, $state, $stateParams, $rootScope) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.deleteEntitat = deleteEntitat;
    vm.edit = edit;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.indexeliminat=-1;

    vm.codivisible=false;
    vm.codiclient=false;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      codiclient: '',
      nif:''
    };

    vm.formulari = {
      nom: 'cercador',
      func: function(){
        cercar();
      },
      camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            columns: 4,
            required: false
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 4,
            required: false,
            show:$rootScope.issuperadmin
           },
           {
             type: 'text',
             name: 'nif',
             label: 'DEFAULT_NIF',
             columns: 4,
             required: false,
             show:$rootScope.issuperadmin
            }
      ]
    }

    function loadEntitats() {
      if (!angular.isUndefined($rootScope.permisos.ENTITAT)){
        var promise = EntitatFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });

        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadEntitats();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadEntitats().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }
    function calculateListFields(reductedList){
        if (!angular.isUndefined($rootScope.permisos.CODI)){
          vm.codivisible=$rootScope.permisos.CODI.read;
        }
        if (!angular.isUndefined($rootScope.permisos.CODIclient)){
          vm.codiclient=$rootScope.permisos.CODIclient.read;
        }
        if (reductedList ||  (!vm.codivisible && !vm.codiclient)){
          vm.fields = [
            {
              header: 'DEFAULT_NOM',
              type: 'text',
              name: 'nom'
            },
            {
              header: 'DEFAULT_ACCIONS',
              type: 'actions',
              name: 'id'
            }
          ];
        }
        else
        {
          vm.fields = [
            {
              header: 'DEFAULT_NOM',
              type: 'text',
              name: 'nom'
            },
            {
              header: 'DEFAULT_CODI_client',
              type: 'text',
              name: 'codiclient'


            },
            {
              header: 'DEFAULT_NIF',
              type: 'text',
              name: 'nif'
            },
            {
              header: 'DEFAULT_CODI',
              type: 'text',
              name: 'codi'
            },
            {
              header: 'DEFAULT_ACCIONS',
              type: 'actions',
              name: 'id'
            }
          ];

        }
    }


    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idEntitat': obj.id});

      if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.ADMINISTRADORSENTMENU) && $rootScope.permisos.ADMINISTRADORSENTMENU.read){
              $state.go('entitats.main.submain.administradors', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.LOGOSMENU) && $rootScope.permisos.LOGOSMENU.read){
              $state.go('entitats.main.submain.logos', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              $state.go('entitats.main.submain.sessions', $stateParams, {'reload': 'entitats.main.submain'});
      }
    }

    function deleteEntitat(id){
      EntitatFactory.delete(id).then(function(response){
      /*  if (id === $stateParams.idEntitat) {
          HelperFactory.setParams($stateParams, {'idEntitat': null});
          $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
        }*/
        vm.indexeliminat=-1;
        vm.llista.forEach( function(obj, index) {
          if (obj.id === id) {
            vm.llista.splice(index, 1);
            vm.indexeliminat=index;
          }
        });
        if (vm.llista.length==0 )
        {
          HelperFactory.setParams($stateParams, {'idEntitat': null});
          $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});
        }
        else
        {
          if (vm.llista.length==1)
          {
            view(vm.llista[0]);
          }
          else{
            if (vm.indexeliminat<vm.llista.length)
            {
              view(vm.llista[vm.indexeliminat]);
            }
            else
            {
              view(vm.llista[vm.indexeliminat-1]);
            }
          }
        }


      });
    }

    function edit(id){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idEntitat': id});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    }

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew':true, 'idEntitat': undefined});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    });

    $scope.$on('entitats.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.toLowerCase().indexOf(vm.cercaObj.nom.toLowerCase()) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('entitats.main.llista.add', function(event, data) {
      $stateParams.idEntitat = data.id;
      if (data.nom.indexOf(vm.cercaObj.nom) != -1) {
        vm.llista.push(data);
      }
      Notification.success('GENERIC_SUCCESS');
    });

    $scope.$on('entitats.main.llista.delete', function(event, id) {
      deleteEntitat(id);
    });

    if (angular.isUndefined($stateParams.idEntitat)){
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
 }
}());
